
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34295',
  depVersions: {
  "documents-public-ui": "static-1.34295",
  "client-types": "static-1.457",
  "documents-lib": "static-1.34300",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.2046",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4938",
  "highcharts": "static-8.102",
  "hs-promise-utils": "static-1.5510",
  "hs-test-utils": "static-1.7928",
  "hub-http": "static-1.6136",
  "hubspot-dlb": "static-2.1832",
  "HubStyleTokens": "static-2.11375",
  "I18n": "static-7.1605",
  "jasmine-immutable": "static-1.2933",
  "jasmine-runner": "static-1.6383",
  "lodash": "static-1.3",
  "quartz": "static-1.6892",
  "react": "static-7.184",
  "react-dlb": "static-1.77",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.70",
  "react-rhumb": "static-1.16574",
  "reporting-data": "static-1.67130",
  "reporting-testing-lib": "static-1.9063",
  "reporting-visualizations": "static-1.59206",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4684",
  "webpack-env": "static-1.54",
  "atom": "static-1.4986",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2409",
  "classnames": "static-2.10",
  "cssUtils": "static-1.772",
  "customer-data-filters-ui": "static-1.39448",
  "customer-data-objects": "static-1.7576",
  "customer-data-property-utils": "static-1.8001",
  "data-fetching-client": "static-1.9590",
  "enviro": "static-4.428",
  "FireAlarmUi": "static-1.4444",
  "flux-actions": "static-1.325",
  "FormsCommonComponents": "static-1.85612",
  "FormUrlGenerator": "static-2.4634",
  "foundations-components": "static-1.7764",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.4049",
  "HubStyle": "static-2.11683",
  "icons": "static-2.639",
  "immutable": "static-2.77",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7074",
  "metrics-js": "static-1.9542",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.388",
  "property-description-translator": "static-1.3767",
  "property-translator": "static-1.5322",
  "quartz-config": "static-1.670",
  "quartz-core": "static-1.6111",
  "quick-fetch": "static-1.3848",
  "raven": "static-3.5829",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5276",
  "react-virtualized": "static-2.97",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8083",
  "reference-resolvers-lite": "static-1.8007",
  "report-customization-components": "static-1.12881",
  "reporting-enablement": "static-1.22580",
  "reporting-reports": "static-1.66808",
  "reporting-snowflake": "static-1.55748",
  "reporting-ui-components": "static-2.64401",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4560",
  "sales-content-partitioning": "static-1.8852",
  "SalesContentIndexUI": "static-3.9112",
  "sanitize": "static-1.4388",
  "sanitize-text": "static-1.8060",
  "self-service-api": "static-1.10160",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1665",
  "signup-constants": "static-1.18697",
  "signup-ui-lego-core": "static-1.20707",
  "signup-ui-url-generator": "static-2.7947",
  "styled-components": "static-2.88",
  "StyleGuideUI": "static-3.485",
  "superstore": "static-1.4684",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10906",
  "ui-addon-i18n": "static-1.11064",
  "ui-addon-react-router-dom": "static-1.9460",
  "ui-addon-upgrades": "static-9.17865",
  "ui-asset-management-lib": "static-1.10907",
  "ui-images": "static-2.1132",
  "UIComponents": "static-3.8322",
  "usage-tracker": "static-1.7251",
  "usage-tracker-container": "static-1.7241",
  "usage-tracker-core": "static-1.7101",
  "usage-tracker-public": "static-1.7062",
  "viral-links-lib": "static-1.6963",
  "hs-promise-rejection-tracking": "static-1.5489",
  "raven-hubspot": "static-1.6136",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3334",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3169",
  "quartz-webpack": "static-1.3116",
  "ai-components-ui-library": "static-1.8730",
  "amplitude-session-replay-browser": "static-1.58",
  "foundations-assets": "static-1.4767",
  "foundations-theming": "static-1.4330",
  "quartz-auth": "static-1.567",
  "ui-business-units-lib": "static-1.8956",
  "usage-tracker-session-replay": "static-1.4937",
  "foundations-theming-base": "static-1.3315",
  "HeadJS": "static-2.736",
  "framer-motion": "static-1.70",
  "hs-test-utils-bend-plugin": "static-1.3039",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "hs-locale-management": "static-1.17",
  "i18n-data": "static-1.219",
  "moment-timezone": "static-5.81",
  "jasmine": "static-4.4239",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7840",
  "graphql": "static-1.80",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3522",
  "persist-promise": "static-1.3625",
  "quartz-i18n": "static-1.567",
  "reporting-client-types": "static-1.2435",
  "foundations-components-legacy": "static-1.789",
  "hs-story-utils": "static-1.9345",
  "react-flip-move": "static-1.68",
  "hub-http-shared-msw-handlers": "static-1.9772",
  "hubspotter-http": "static-1.4584",
  "sassPrefix": "static-1.154",
  "conversations-skeleton-state": "static-1.7166",
  "crm-message-bus": "static-1.42752",
  "customer-data-filters-ui-msw-helpers": "static-1.21883",
  "customer-data-objects-ui-components": "static-1.12936",
  "customer-data-reference-ui-components": "static-1.13072",
  "customer-data-ui-utilities": "static-1.9741",
  "framework-builder-read-service-client": "static-1.3941",
  "framework-data-schema-quick-fetch": "static-1.6696",
  "framework-data-schema-resolvers": "static-1.6791",
  "inbound-db-properties-service-client": "static-1.3775",
  "multi-account-reference-resolvers": "static-1.891",
  "onboarding-tours": "static-1.16446",
  "reporting-datasets-permissions-lib": "static-1.13429",
  "ui-addon-teams": "static-1.21435",
  "apollo-stack-hubspot": "static-3.84",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.68096",
  "customer-data-properties": "static-1.51247",
  "forms-ai-lib": "static-1.4186",
  "forms-utils-lib": "static-1.12423",
  "foundations-components-test-utils": "static-1.5247",
  "react-dnd-compat": "static-1.4534",
  "react-tinymce": "static-1.54997",
  "tinymce-config": "static-2.54123",
  "ui-gdpr-components": "static-1.10263",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4033",
  "floating-ui": "static-1.54",
  "react-aria": "static-1.64",
  "tanstack-table": "static-1.53",
  "trellis-assets": "static-1.1576",
  "ui-fonts": "static-1.637",
  "dispatcher": "static-1.134",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.820",
  "mobile-manifest-mixins": "static-1.510",
  "module-federation": "static-1.21",
  "quartz-head": "static-1.557",
  "quartz-routing": "static-1.322",
  "quartz-test": "static-1.567",
  "quartz-tracking": "static-1.271",
  "batch-promise": "static-1.1468",
  "external-options-client-types": "static-1.4090",
  "react-colorpicker": "static-2.10125",
  "copilot-toolkit": "static-1.10894",
  "data-quality-ui-library": "static-1.12657",
  "html-to-image": "static-1.52",
  "onboarding-scopes": "static-1.6380",
  "reporting-action-components": "static-1.41046",
  "reporting-insights-lib": "static-1.1474",
  "reporting-plugins": "static-1.10160",
  "ui-addon-draggable-compat": "static-2.4170",
  "ui-addon-opt": "static-4.8296",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.25116",
  "hubspot-apollo-client": "static-1.4793",
  "chirp-fetch": "static-1.1798",
  "sales-templates-service-types-lib": "static-1.4100",
  "merchandise-lib": "static-1.262",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5716",
  "salesImages": "static-1.523",
  "ts-schema": "static-1.4010",
  "nested-table": "static-1.140",
  "timezone-utils": "static-2.5159",
  "bender-build-tools": "static-1.3063",
  "chatspot-core": "static-1.20902",
  "bend-plugin-foundations-theming": "static-1.2813",
  "stylex": "static-1.30",
  "hubspotter-http-shared-msw-handlers": "static-1.9770",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3729",
  "crm-pipelines-api-client-types": "static-1.4074",
  "multi-currency-client-types": "static-1.3623",
  "getting-started-shared-tasks": "static-1.18260",
  "growth-data-modal": "static-1.5298",
  "growth-onboarding-confetti": "static-1.2986",
  "growth-onboarding-next-action-utils": "static-1.1667",
  "navigation-components": "static-1.17722",
  "onboarding-tours-client": "static-1.4660",
  "onboarding-tours-utils": "static-1.512",
  "ui-shepherd-react": "static-3.10063",
  "ui-shepherd-tracker": "static-1.7444",
  "ui-universal-auth": "static-1.8868",
  "user-context": "static-1.5016",
  "cms-field-types": "static-1.4725",
  "content-icons-ui": "static-1.2205",
  "integrations-lib": "static-1.15844",
  "calling-global-api": "static-1.64171",
  "calling-internal-common": "static-1.31217",
  "calling-lifecycle-internal": "static-1.65553",
  "calling-lifecycle-messages": "static-1.57847",
  "commerce-products-lib": "static-1.9214",
  "crm-links": "static-1.6194",
  "customer-data-properties-shared-msw-handlers": "static-1.9099",
  "file-manager-components": "static-1.23356",
  "google-libphonenumber": "static-1.36",
  "hs-resources": "static-1.57",
  "inbounddb-objects-service-types": "static-1.4155",
  "meetings-icalendar-utils-lib": "static-1.545",
  "object-builder-ui-client": "static-1.48456",
  "pipeline-validation-client-types": "static-1.3898",
  "property-value-citations": "static-1.1861",
  "pulse": "static-1.461",
  "smart-property-lib": "static-1.6506",
  "tiered-pricing": "static-1.1038",
  "ui-addon-iframeable": "static-1.8967",
  "final-form": "static-1.68",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19687",
  "tinymce-themes": "static-1.56093",
  "data-token-picker": "static-1.16258",
  "hub-http-contrib": "static-1.2958",
  "interframe": "static-3.4678",
  "tinymce-data": "static-1.40208",
  "tinymce-plugins": "static-1.57237",
  "ui-addon-sales-email": "static-1.5127",
  "magpie-lib": "static-1.5509",
  "magpie-types": "static-1.4969",
  "simple-logging-lib": "static-1.2967",
  "content-assistance-lib": "static-1.7629",
  "dashboard-lib": "static-1.81186",
  "ExportDialog": "static-6.10305",
  "hubspot-prosemirror": "static-1.17994",
  "hubspot-prosemirror-plugins": "static-1.17986",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8611",
  "campaign-roi-lib": "static-1.8723",
  "feedback-loader": "static-1.29143",
  "apollo-link-hub-http": "static-2.4566",
  "hubspot-apollo-cache": "static-1.252",
  "nav-client-types": "static-1.2273",
  "purchase-motions-api": "static-1.5719",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.88",
  "markdown-it": "static-1.6",
  "onboarding-data-sync-lib": "static-1.1818",
  "growth-onboarding-next-action-components": "static-1.1695",
  "user-context-client": "static-1.4527",
  "idb-keyval": "static-1.42",
  "nest": "static-1.139",
  "reactive-lib": "static-1.639",
  "unified-auth-core-lib": "static-1.663",
  "getting-started-shared-tasks-store": "static-1.17378",
  "integrations-error-boundary-lib": "static-1.13259",
  "integrations-tracking-lib": "static-1.5513",
  "native-integrations-shared-strings": "static-1.7701",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10289",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.382",
  "calling-error-reporting": "static-1.31223",
  "shared-worker-versioning": "static-1.10953",
  "calling-usage-tracker": "static-1.6456",
  "voice-sms-access-library": "static-1.659",
  "customer-data-tracking": "static-1.6800",
  "commerce-permissions": "static-1.681",
  "products-iframe-lib": "static-1.7689",
  "products-ui-components-shared-msw-handlers": "static-1.10154",
  "location-customization-utils-lib": "static-1.8981",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4068",
  "video-components-external": "static-1.11001",
  "video-data-lib": "static-1.34659",
  "directed-graph": "static-1.853",
  "event-emitter": "static-1.863",
  "fast-json-patch": "static-1.61",
  "data-agent-kit": "static-1.63",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9855",
  "fsm": "static-1.3650",
  "policy-lib": "static-1.6699",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9918",
  "navigation-messaging": "static-1.7049",
  "FileManagerLib": "static-1.38996",
  "NamespacedHubStyle": "static-2.8998",
  "FileManagerCore": "static-1.38855",
  "codemirror": "static-5.93",
  "layout-dnd-components": "static-1.12282",
  "layout-dnd-utils": "static-1.11257",
  "react-codemirror": "static-1.10539",
  "ui-addon-emoji-picker": "static-1.9802",
  "ui-brand-identity-lib": "static-1.14870",
  "ui-addon-video-player": "static-1.8612",
  "ui-coaching-tips": "static-1.28305",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8461",
  "payment-link-components": "static-1.23289",
  "EmailSignatureEditor": "static-1.24191",
  "InboxConnectUtils": "static-4.14574",
  "universal-page-editor-lib": "static-1.2925",
  "microsoft-drive-integration-lib": "static-1.77",
  "calling-orchestration-schema": "static-1.35436",
  "sales-views-client-types": "static-1.4178",
  "crm-record-cards-service-types": "static-1.3542",
  "content-media-composition-data-lib": "static-1.11990",
  "content-media-compositions": "static-2.15997",
  "media-bridge-lib": "static-1.18779",
  "trellis-story-utils": "static-1.4433",
  "storybook-react": "static-1.31",
  "audio-components": "static-1.5791",
  "FileManagerImages": "static-1.36507",
  "video-components": "static-1.13004",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4447",
  "video-embed": "static-1.35493",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68171",
  "layout-data-lib": "static-1.9582",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6497",
  "commerce-tours-lib": "static-1.5940",
  "growth-onboarding-reliability": "static-1.5000",
  "sales-checkout-service-client": "static-1.3569",
  "draft-convert": "static-2.71",
  "draft-extend": "static-3.73",
  "draft-js": "static-5.76",
  "draft-plugins": "static-2.21527",
  "sales-email-signature-service-client": "static-1.3758",
  "social-insights-client-types": "static-1.21846",
  "outpost": "static-1.4108",
  "advanced-menus-core": "static-1.15000",
  "advanced-menus-lib": "static-1.11957",
  "ui-memberships-settings-lib": "static-1.33808",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14999",
  "simple-menus-lib": "static-1.16516"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34295",
  "client-types": "/client-types/static-1.457",
  "documents-lib": "/documents-lib/static-1.34300",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2046",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4938",
  "highcharts": "/highcharts/static-8.102",
  "hs-promise-utils": "/hs-promise-utils/static-1.5510",
  "hs-test-utils": "/hs-test-utils/static-1.7928",
  "hub-http": "/hub-http/static-1.6136",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "HubStyleTokens": "/HubStyleTokens/static-2.11375",
  "I18n": "/I18n/static-7.1605",
  "jasmine-immutable": "/jasmine-immutable/static-1.2933",
  "jasmine-runner": "/jasmine-runner/static-1.6383",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6892",
  "react": "/react/static-7.184",
  "react-dlb": "/react-dlb/static-1.77",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.70",
  "react-rhumb": "/react-rhumb/static-1.16574",
  "reporting-data": "/reporting-data/static-1.67130",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9063",
  "reporting-visualizations": "/reporting-visualizations/static-1.59206",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4684",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4986",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2409",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.772",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39448",
  "customer-data-objects": "/customer-data-objects/static-1.7576",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8001",
  "data-fetching-client": "/data-fetching-client/static-1.9590",
  "enviro": "/enviro/static-4.428",
  "FireAlarmUi": "/FireAlarmUi/static-1.4444",
  "flux-actions": "/flux-actions/static-1.325",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85612",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4634",
  "foundations-components": "/foundations-components/static-1.7764",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyle": "/HubStyle/static-2.11683",
  "icons": "/icons/static-2.639",
  "immutable": "/immutable/static-2.77",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7074",
  "metrics-js": "/metrics-js/static-1.9542",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "property-description-translator": "/property-description-translator/static-1.3767",
  "property-translator": "/property-translator/static-1.5322",
  "quartz-config": "/quartz-config/static-1.670",
  "quartz-core": "/quartz-core/static-1.6111",
  "quick-fetch": "/quick-fetch/static-1.3848",
  "raven": "/raven/static-3.5829",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5276",
  "react-virtualized": "/react-virtualized/static-2.97",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8083",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8007",
  "report-customization-components": "/report-customization-components/static-1.12881",
  "reporting-enablement": "/reporting-enablement/static-1.22580",
  "reporting-reports": "/reporting-reports/static-1.66808",
  "reporting-snowflake": "/reporting-snowflake/static-1.55748",
  "reporting-ui-components": "/reporting-ui-components/static-2.64401",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4560",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8852",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9112",
  "sanitize": "/sanitize/static-1.4388",
  "sanitize-text": "/sanitize-text/static-1.8060",
  "self-service-api": "/self-service-api/static-1.10160",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1665",
  "signup-constants": "/signup-constants/static-1.18697",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20707",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7947",
  "styled-components": "/styled-components/static-2.88",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "superstore": "/superstore/static-1.4684",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10906",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11064",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9460",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17865",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10907",
  "ui-images": "/ui-images/static-2.1132",
  "UIComponents": "/UIComponents/static-3.8322",
  "usage-tracker": "/usage-tracker/static-1.7251",
  "usage-tracker-container": "/usage-tracker-container/static-1.7241",
  "usage-tracker-core": "/usage-tracker-core/static-1.7101",
  "usage-tracker-public": "/usage-tracker-public/static-1.7062",
  "viral-links-lib": "/viral-links-lib/static-1.6963",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3334",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3169",
  "quartz-webpack": "/quartz-webpack/static-1.3116",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8730",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
  "foundations-assets": "/foundations-assets/static-1.4767",
  "foundations-theming": "/foundations-theming/static-1.4330",
  "quartz-auth": "/quartz-auth/static-1.567",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8956",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4937",
  "foundations-theming-base": "/foundations-theming-base/static-1.3315",
  "HeadJS": "/HeadJS/static-2.736",
  "framer-motion": "/framer-motion/static-1.70",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3039",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "hs-locale-management": "/hs-locale-management/static-1.17",
  "i18n-data": "/i18n-data/static-1.219",
  "moment-timezone": "/moment-timezone/static-5.81",
  "jasmine": "/jasmine/static-4.4239",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7840",
  "graphql": "/graphql/static-1.80",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3522",
  "persist-promise": "/persist-promise/static-1.3625",
  "quartz-i18n": "/quartz-i18n/static-1.567",
  "reporting-client-types": "/reporting-client-types/static-1.2435",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.789",
  "hs-story-utils": "/hs-story-utils/static-1.9345",
  "react-flip-move": "/react-flip-move/static-1.68",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9772",
  "hubspotter-http": "/hubspotter-http/static-1.4584",
  "sassPrefix": "/sassPrefix/static-1.154",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7166",
  "crm-message-bus": "/crm-message-bus/static-1.42752",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21883",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12936",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13072",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9741",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3941",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6696",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6791",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3775",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.891",
  "onboarding-tours": "/onboarding-tours/static-1.16446",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13429",
  "ui-addon-teams": "/ui-addon-teams/static-1.21435",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.68096",
  "customer-data-properties": "/customer-data-properties/static-1.51247",
  "forms-ai-lib": "/forms-ai-lib/static-1.4186",
  "forms-utils-lib": "/forms-utils-lib/static-1.12423",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5247",
  "react-dnd-compat": "/react-dnd-compat/static-1.4534",
  "react-tinymce": "/react-tinymce/static-1.54997",
  "tinymce-config": "/tinymce-config/static-2.54123",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10263",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4033",
  "floating-ui": "/floating-ui/static-1.54",
  "react-aria": "/react-aria/static-1.64",
  "tanstack-table": "/tanstack-table/static-1.53",
  "trellis-assets": "/trellis-assets/static-1.1576",
  "ui-fonts": "/ui-fonts/static-1.637",
  "dispatcher": "/dispatcher/static-1.134",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.820",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.510",
  "module-federation": "/module-federation/static-1.21",
  "quartz-head": "/quartz-head/static-1.557",
  "quartz-routing": "/quartz-routing/static-1.322",
  "quartz-test": "/quartz-test/static-1.567",
  "quartz-tracking": "/quartz-tracking/static-1.271",
  "batch-promise": "/batch-promise/static-1.1468",
  "external-options-client-types": "/external-options-client-types/static-1.4090",
  "react-colorpicker": "/react-colorpicker/static-2.10125",
  "copilot-toolkit": "/copilot-toolkit/static-1.10894",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12657",
  "html-to-image": "/html-to-image/static-1.52",
  "onboarding-scopes": "/onboarding-scopes/static-1.6380",
  "reporting-action-components": "/reporting-action-components/static-1.41046",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1474",
  "reporting-plugins": "/reporting-plugins/static-1.10160",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4170",
  "ui-addon-opt": "/ui-addon-opt/static-4.8296",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.25116",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4793",
  "chirp-fetch": "/chirp-fetch/static-1.1798",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4100",
  "merchandise-lib": "/merchandise-lib/static-1.262",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5716",
  "salesImages": "/salesImages/static-1.523",
  "ts-schema": "/ts-schema/static-1.4010",
  "nested-table": "/nested-table/static-1.140",
  "timezone-utils": "/timezone-utils/static-2.5159",
  "bender-build-tools": "/bender-build-tools/static-1.3063",
  "chatspot-core": "/chatspot-core/static-1.20902",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2813",
  "stylex": "/stylex/static-1.30",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9770",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3729",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4074",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3623",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18260",
  "growth-data-modal": "/growth-data-modal/static-1.5298",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2986",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1667",
  "navigation-components": "/navigation-components/static-1.17722",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4660",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.512",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10063",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7444",
  "ui-universal-auth": "/ui-universal-auth/static-1.8868",
  "user-context": "/user-context/static-1.5016",
  "cms-field-types": "/cms-field-types/static-1.4725",
  "content-icons-ui": "/content-icons-ui/static-1.2205",
  "integrations-lib": "/integrations-lib/static-1.15844",
  "calling-global-api": "/calling-global-api/static-1.64171",
  "calling-internal-common": "/calling-internal-common/static-1.31217",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65553",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57847",
  "commerce-products-lib": "/commerce-products-lib/static-1.9214",
  "crm-links": "/crm-links/static-1.6194",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9099",
  "file-manager-components": "/file-manager-components/static-1.23356",
  "google-libphonenumber": "/google-libphonenumber/static-1.36",
  "hs-resources": "/hs-resources/static-1.57",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4155",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.545",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48456",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3898",
  "property-value-citations": "/property-value-citations/static-1.1861",
  "pulse": "/pulse/static-1.461",
  "smart-property-lib": "/smart-property-lib/static-1.6506",
  "tiered-pricing": "/tiered-pricing/static-1.1038",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8967",
  "final-form": "/final-form/static-1.68",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19687",
  "tinymce-themes": "/tinymce-themes/static-1.56093",
  "data-token-picker": "/data-token-picker/static-1.16258",
  "hub-http-contrib": "/hub-http-contrib/static-1.2958",
  "interframe": "/interframe/static-3.4678",
  "tinymce-data": "/tinymce-data/static-1.40208",
  "tinymce-plugins": "/tinymce-plugins/static-1.57237",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5127",
  "magpie-lib": "/magpie-lib/static-1.5509",
  "magpie-types": "/magpie-types/static-1.4969",
  "simple-logging-lib": "/simple-logging-lib/static-1.2967",
  "content-assistance-lib": "/content-assistance-lib/static-1.7629",
  "dashboard-lib": "/dashboard-lib/static-1.81186",
  "ExportDialog": "/ExportDialog/static-6.10305",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17994",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17986",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8611",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8723",
  "feedback-loader": "/feedback-loader/static-1.29143",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4566",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.252",
  "nav-client-types": "/nav-client-types/static-1.2273",
  "purchase-motions-api": "/purchase-motions-api/static-1.5719",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.88",
  "markdown-it": "/markdown-it/static-1.6",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1818",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1695",
  "user-context-client": "/user-context-client/static-1.4527",
  "idb-keyval": "/idb-keyval/static-1.42",
  "nest": "/nest/static-1.139",
  "reactive-lib": "/reactive-lib/static-1.639",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.663",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17378",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13259",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5513",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7701",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10289",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.382",
  "calling-error-reporting": "/calling-error-reporting/static-1.31223",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10953",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6456",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.659",
  "customer-data-tracking": "/customer-data-tracking/static-1.6800",
  "commerce-permissions": "/commerce-permissions/static-1.681",
  "products-iframe-lib": "/products-iframe-lib/static-1.7689",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10154",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8981",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4068",
  "video-components-external": "/video-components-external/static-1.11001",
  "video-data-lib": "/video-data-lib/static-1.34659",
  "directed-graph": "/directed-graph/static-1.853",
  "event-emitter": "/event-emitter/static-1.863",
  "fast-json-patch": "/fast-json-patch/static-1.61",
  "data-agent-kit": "/data-agent-kit/static-1.63",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9855",
  "fsm": "/fsm/static-1.3650",
  "policy-lib": "/policy-lib/static-1.6699",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9918",
  "navigation-messaging": "/navigation-messaging/static-1.7049",
  "FileManagerLib": "/FileManagerLib/static-1.38996",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8998",
  "FileManagerCore": "/FileManagerCore/static-1.38855",
  "codemirror": "/codemirror/static-5.93",
  "layout-dnd-components": "/layout-dnd-components/static-1.12282",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11257",
  "react-codemirror": "/react-codemirror/static-1.10539",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9802",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14870",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8612",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28305",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8461",
  "payment-link-components": "/payment-link-components/static-1.23289",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24191",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14574",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2925",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.77",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35436",
  "sales-views-client-types": "/sales-views-client-types/static-1.4178",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3542",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11990",
  "content-media-compositions": "/content-media-compositions/static-2.15997",
  "media-bridge-lib": "/media-bridge-lib/static-1.18779",
  "trellis-story-utils": "/trellis-story-utils/static-1.4433",
  "storybook-react": "/storybook-react/static-1.31",
  "audio-components": "/audio-components/static-1.5791",
  "FileManagerImages": "/FileManagerImages/static-1.36507",
  "video-components": "/video-components/static-1.13004",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4447",
  "video-embed": "/video-embed/static-1.35493",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68171",
  "layout-data-lib": "/layout-data-lib/static-1.9582",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6497",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5940",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5000",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3569",
  "draft-convert": "/draft-convert/static-2.71",
  "draft-extend": "/draft-extend/static-3.73",
  "draft-js": "/draft-js/static-5.76",
  "draft-plugins": "/draft-plugins/static-2.21527",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3758",
  "social-insights-client-types": "/social-insights-client-types/static-1.21846",
  "outpost": "/outpost/static-1.4108",
  "advanced-menus-core": "/advanced-menus-core/static-1.15000",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11957",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33808",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14999",
  "simple-menus-lib": "/simple-menus-lib/static-1.16516"
}
};
